/* eslint-disable unicorn/no-abusive-eslint-disable */
/* eslint-disable */
// @ts-nocheck
const runLocalizeSnippet = () => {
  /**
   * This is the contents of the script tags recommended in the Localize setup docs. This must
   * be in a separate file so we can avoid opening up the CSP to allow for script tags in index.html.
   *
   * https://developers.localizejs.com/docs/library-api
   */
  !(function (a) {
    if (!a.Localize) {
      a.Localize = {}
      for (
        var e = [
            'translate',
            'untranslate',
            'phrase',
            'initialize',
            'translatePage',
            'setLanguage',
            'getLanguage',
            'getSourceLanguage',
            'detectLanguage',
            'getAvailableLanguages',
            'untranslatePage',
            'bootstrap',
            'prefetch',
            'on',
            'off',
            'hideWidget',
            'showWidget',
          ],
          t = 0;
        t < e.length;
        t++
      )
        a.Localize[e[t]] = function () {}
    }
  })(window)

  Localize.initialize({
    key: 'BtJUSluTq0Mnt',
  })
}
/* eslint-enable */

export default runLocalizeSnippet
